import { GET_JOBS, GET_JOBS_SUCCESS, GET_JOBS_FAILURE, EXPORT_JOBS, EXPORT_JOBS_SUCCESS, EXPORT_JOBS_FAILURE, JOB_DETAIL, JOB_DETAIL_SUCCESS, JOB_DETAIL_FAILURE, GET_SERVICE_PROVIDERS, GET_SERVICE_PROVIDERS_SUCCESS, GET_SERVICE_PROVIDERS_FAILURE, ASSIGN_SERVICE_PROVIDER, ASSIGN_SERVICE_PROVIDER_SUCCESS, ASSIGN_SERVICE_PROVIDER_FAILURE } from "../constants";

export default class JobActions {

    static getAllJobs(payload, cb) {
        return {
            type: GET_JOBS,
            payload,
            cb,
        };
    }

    static getAllJobsSuccess(payload) {
        return {
            type: GET_JOBS_SUCCESS,
            payload,
        };
    }

    static getAllJobsFailure() {
        return {
            type: GET_JOBS_FAILURE,
        };
    }

    static exportJobs(payload, cb) {
        return {
            type: EXPORT_JOBS,
            payload,
            cb,
        };
    }

    static exportJobsSuccess(payload) {
        return {
            type: EXPORT_JOBS_SUCCESS,
            payload,
        };
    }

    static exportJobsFailure() {
        return {
            type: EXPORT_JOBS_FAILURE,
        };
    }

    static jobsDetail(payload, cb) {
        // console.log(payload)
        return {
            type: JOB_DETAIL,
            payload,
            cb,
        };
    }

    static jobDetailSuccess(payload) {
        return {
            type: JOB_DETAIL_SUCCESS,
            payload,
        };
    }

    static jobDetailFailure() {
        return {
            type: JOB_DETAIL_FAILURE,
        };
    }
    static getServiceProviders(payload, cb) {
        // alert("get service provider action")
        // console.log('get service provider action payload', payload)
        return {
            type: GET_SERVICE_PROVIDERS,
            payload,
            cb,
        };
    }

    static getServiceProvidersSuccess(payload) {
        // alert('get service provider success action')
        // console.log('get service provider success action payload', payload)

        return {
            type: GET_SERVICE_PROVIDERS_SUCCESS,
            payload,
        };
    }

    static getServiceProvidersFailure() {
        // alert('get service provider fail action')
        return {
            type: GET_SERVICE_PROVIDERS_FAILURE,
        };
    }
    static assignServiceProvider( payload, cb) {
        // alert('get service provider fail action')
        return {
            type: ASSIGN_SERVICE_PROVIDER,
            payload,
            cb,
        };
    }
    static assignServiceProviderSuccess( payload, cb) {
        // alert('get service provider fail action')
        return {
            type: ASSIGN_SERVICE_PROVIDER_SUCCESS,
            payload
        };
    }
    static assignServiceProviderFailure() {
        // alert('get service provider fail action')
        return {
            type: ASSIGN_SERVICE_PROVIDER_FAILURE,
        };
    }

}